import Marquee from "react-fast-marquee";

const WORDS = ["Per la casa", "Selezionati con cura", "AB fëlise", "Utili ogni giorno", "Spedizione in 24h"];

export default function EditorialMarquee() {
  return (
    <div
      className="border-y border-white/10 py-10 md:py-14 overflow-hidden select-none"
      data-testid="editorial-marquee"
    >
      <Marquee speed={28} gradient={false} pauseOnHover>
        {WORDS.map((w) => (
          <span key={w} className="flex items-center">
            <span className="font-serif italic font-light text-4xl md:text-6xl text-white/20 mx-14">
              {w}
            </span>
            <span className="text-primary/40 text-2xl">—</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
